// Ð¡Ð´ÐµÐ»ÐºÐ° Ð·Ð°ÐºÑÑÑÐ° TTL-Ð´Ð¶Ð¾Ð±Ð¾Ð¹: Ð·Ð°ÑÐ²ÐºÐ° Ð¸Ð· Ð¼Ð¾Ð±Ð¸Ð»ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ, Ð±Ð°Ð½ÐºÐ¸ Ð½Ðµ Ð¾ÑÐ²ÐµÑÐ¸Ð»Ð¸ Ð·Ð° 2 ÑÐ°ÑÐ°
// (MobileAppCreditTtlExpiry). Ð¡Ð½Ð¸Ð¼Ð°ÐµÑÑÑ Ð·Ð°Ð¼ÐµÐ½Ð¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ñ â reassignCar.
export const DEAL_STATUS_TTL_EXPIRED = 24;
